import { Hover } from "react-powerplug";
import type { ICommentOrReplyAuthorFieldsFragment } from "../../lib/graphql/fragments/__generated__/CommentOrReplyAuthorFields.generated";
import Avatar from "../core/Avatar";
import * as palette from "../palette";

interface IAssetDiscussionCommentParticipantsProps {
  participants: ICommentOrReplyAuthorFieldsFragment[];
  totalCount: number;
}

export default function AssetDiscussionCommentParticipants({
  participants,
  totalCount,
}: IAssetDiscussionCommentParticipantsProps) {
  if (participants.length === 0) {
    return null;
  }

  const isTruncated = totalCount > participants.length;
  const othersCount = totalCount - participants.length;

  return (
    <Hover>
      {({ hovered, bind }) => {
        return (
          <div
            css={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <div
              {...bind}
              css={{
                display: "flex",
                alignItems: "center",
              }}
            >
              {participants.map((participant, index) => {
                const isFirstParticipant = index === 0;

                return (
                  <Avatar
                    key={participant._id}
                    hashValue={participant._id}
                    src={participant.pictureUrl}
                    alt={participant.fullName}
                    title={participant.fullName}
                    variant="squared"
                    size={19}
                    css={{
                      zIndex: participants.length - index,
                      // eslint-disable-next-line no-nested-ternary
                      marginLeft: isFirstParticipant ? 0 : hovered ? 4 : -4,
                      fontWeight: 700,
                      fontSize: 11,
                      lineHeight: "11px",
                      border: `solid 1px ${palette.white}`,
                    }}
                  />
                );
              })}
            </div>

            {isTruncated && (
              <div
                css={{
                  display: "inline-flex",
                  marginLeft: 4,
                }}
              >
                <div
                  title={
                    othersCount === 1
                      ? "Outra pessoa também respondeu ao comentário"
                      : `Outras ${othersCount} pessoas também responderam`
                  }
                  draggable={false}
                  css={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxSizing: "border-box",
                    width: 19,
                    height: 19,
                    color: palette.royalBlue,
                    fontWeight: 700,
                    fontSize: 11,
                    lineHeight: "11px",
                    backgroundColor: palette.selago,
                    borderRadius: 4,
                    userSelect: "none",
                  }}
                >
                  <span>+{Math.min(Math.max(othersCount, 0), 9)}</span>
                </div>
              </div>
            )}
          </div>
        );
      }}
    </Hover>
  );
}
